export default "__VITE_ASSET__DYaPQhog__"